import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { useDevices, useTradeInConfiguration } from "@jti/rest-api";
import { updateTradeInOrderAttributes } from "@jti/store";
import { Select, useTranslations } from "@jti/ui";
export const TradeInSelect = ({ sku }) => {
    const { __ } = useTranslations();
    const { data: responseData, isLoadingData: isLoadingDevices } = useDevices();
    const registeredDevices = responseData?.data;
    const dispatch = useDispatch();
    const { defaultDevices, isUsingRegisteredDevices, isLoading: isLoadingTradeInConfiguration, } = useTradeInConfiguration();
    const defaultDevicesOptions = (defaultDevices || []).map((device) => ({
        deviceId: device,
        deviceName: device,
    }));
    const devices = isUsingRegisteredDevices ? registeredDevices : defaultDevicesOptions;
    const onValueChange = (newValue) => {
        const { value, label } = newValue;
        const serialNumber = isUsingRegisteredDevices ? value : "";
        dispatch(updateTradeInOrderAttributes({
            traded_in_new_sku: sku,
            traded_in_model: label,
            traded_in_serial_number: serialNumber,
        }));
    };
    return (_jsx(Select, { placeholder: __("cart.cart_item.trade_in.select.placeholder"), isIconHidden: true, options: devices?.map(({ deviceId, deviceName }) => ({
            value: deviceId,
            label: deviceName ?? deviceId,
        })) || [], isLoading: isLoadingDevices || isLoadingTradeInConfiguration, onChange: onValueChange }));
};
//# sourceMappingURL=TradeInSelect.js.map